"use client";


import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import React from 'react'

const ApplyNow = () => {
    return (
        <div>
            <section className="py-10 mt-14 bg-[#FFA500]">
                <div className="page-container w-full  flex flex-col md:flex-col lg:flex-row items-center justify-between text-black">
                    <p className="w-full md:w-[80%] lg:w-[70%] text-[24px] md:text-[30px] lg:text-[42px] font-semibold text-center md:text-left leading-snug"
                    style={{ fontFamily: 'saans-bold' }}
                    >
                       Apply Now for <span className="font-bold">2026 Admissions & Graduate</span> With a Degree and Real-World Experience

                    </p>
                    <Link
                        href="https://application.msu.edu.in/campus-programme-registration"
                        className="w-full md:w-full lg:w-auto mt-4 md:mt-6 lg:mt-0 flex justify-center 
                items-center gap-3 bg-[#081E2D] text-white px-8 py-3 transition-all duration-300"
                    >
                        <span className="text-white">Apply Now</span>
                        <span className="cursor-pointer text-white  material-symbols-outlined text-lg transition-all duration-300 ">
                            <ArrowRight />
                        </span>
                    </Link>
                </div>
            </section>
        </div>
    )
}

export default ApplyNow